var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "main_form" },
        [
          _c(
            "el-form",
            {
              ref: "queryForm",
              attrs: { inline: true, model: _vm.queryModel, size: "small" }
            },
            [
              _c(
                "el-form-item",
                { staticClass: "search_form_item", attrs: { prop: "userId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("m.live_ID"), clearable: "" },
                    model: {
                      value: _vm.queryModel.userId,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.queryModel,
                          "userId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "queryModel.userId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "search_form_item", attrs: { prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("m.audit_status"),
                        clearable: ""
                      },
                      model: {
                        value: _vm.queryModel.status,
                        callback: function($$v) {
                          _vm.$set(_vm.queryModel, "status", $$v)
                        },
                        expression: "queryModel.status"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: 5, label: _vm.$t("m.pending_review") }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: 6, label: _vm.$t("m.approved") }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: 7, label: _vm.$t("m.not_approved") }
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { value: 15, label: _vm.$t("m.withdrawn") }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("m.apply_time")
                        },
                        model: {
                          value: _vm.queryModel.applyStartTime,
                          callback: function($$v) {
                            _vm.$set(_vm.queryModel, "applyStartTime", $$v)
                          },
                          expression: "queryModel.applyStartTime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { staticClass: "coldiv", attrs: { span: 1 } }, [
                    _vm._v("~")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("m.apply_time")
                        },
                        model: {
                          value: _vm.queryModel.applyEndTime,
                          callback: function($$v) {
                            _vm.$set(_vm.queryModel, "applyEndTime", $$v)
                          },
                          expression: "queryModel.applyEndTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-wrapper" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.onQueryBtnClick }
                },
                [_vm._v(_vm._s(_vm.$t("m.search")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: { click: _vm.resetForm }
                },
                [_vm._v(_vm._s(_vm.$t("m.reset")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main_table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading.table,
                  expression: "loading.table"
                }
              ],
              ref: "tableOrder",
              staticStyle: { width: "100%", "margin-bottom": "10px" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "element-loading-text": "",
                "element-loading-spinner": "el-icon-loading"
              }
            },
            [
              _c("el-table-column", { attrs: { prop: "id", label: "ID" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "userId", label: _vm.$t("m.live_ID") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userName",
                  label: _vm.$t("m.sereamer_nickname")
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.getUnionDetail(scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(scope.row.userName))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "reqComplain",
                  label: _vm.$t("m.termination_reason"),
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "fileList", label: _vm.$t("m.img_material") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.fileList &&
                        scope.row.fileList.length > 0 &&
                        scope.row.fileList[0].url
                          ? _c("img", {
                              staticClass: "img-thumb",
                              attrs: { src: scope.row.fileList[0].url },
                              on: {
                                click: function($event) {
                                  return _vm.showPicPreviewDialog(
                                    scope.row.fileList
                                  )
                                }
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "cancelTime", label: _vm.$t("m.apply_time") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: _vm.$t("m.audit_status") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.status === 5
                          ? _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "warning" } },
                              [_vm._v(_vm._s(_vm.$t("m.pending_review")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 6
                          ? _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "success" } },
                              [_vm._v(_vm._s(_vm.$t("m.approved")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 7
                          ? _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "danger" } },
                              [_vm._v(_vm._s(_vm.$t("m.not_approved")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status === 15
                          ? _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "info" } },
                              [_vm._v(_vm._s(_vm.$t("m.withdrawn")))]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "approverName", label: _vm.$t("m.approver") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.status !== 5
                          ? _c("span", [_vm._v(_vm._s(scope.row.approverName))])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: _vm.$t("m.oper") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", { staticClass: "oper-group-btn" }, [
                          scope.row.status === 5
                            ? _c(
                                "span",
                                {
                                  staticClass: "fc-color-main",
                                  on: {
                                    click: function($event) {
                                      return _vm.passApplication(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("m.pass")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.status === 5
                            ? _c(
                                "span",
                                {
                                  staticClass: "fc-color-main",
                                  on: {
                                    click: function($event) {
                                      return _vm.rejectApplication(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("m.refused")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "fc-color-main",
                              on: {
                                click: function($event) {
                                  return _vm.openAuditingLogDialog(scope.row)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("m.audit_trail")))]
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pager.page,
              "page-sizes": [10, 20, 30, 100, 300, 500],
              "page-size": _vm.pager.limit,
              small: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pager.total,
              "pager-count": 5
            },
            on: {
              "size-change": _vm.onSizeChange,
              "current-change": _vm.onCurrentPageChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialog.reject.show,
            title: _vm.$t("m.leave_agency_apply"),
            "close-on-click-modal": false,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialog.reject, "show", $event)
            },
            close: function($event) {
              return _vm.$refs.rejectForm.resetFields()
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "rejectForm",
              attrs: {
                model: _vm.dialog.reject.model,
                rules: _vm.dialog.reject.rules,
                size: "small",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "refuseReason",
                    label: _vm.$t("m.rejection_reason") + ":",
                    "label-width": "100px"
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: _vm.$t("m.rejection_reason"),
                      maxlength: "50"
                    },
                    model: {
                      value: _vm.dialog.reject.model.refuseReason,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.dialog.reject.model,
                          "refuseReason",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "dialog.reject.model.refuseReason"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.dialog.reject.show = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("m.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.dialog.reject.btnLoading
                  },
                  on: { click: _vm.doEdit }
                },
                [_vm._v(_vm._s(_vm.$t("m.Confirm")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialog.picture.show,
            title: _vm.$t("m.preview") + ":",
            "close-on-click-modal": false,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialog.picture, "show", $event)
            },
            close: _vm.resetInfoForm
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialog.picture.loading,
                  expression: "dialog.picture.loading"
                }
              ]
            },
            [
              _c(
                "el-carousel",
                {
                  attrs: {
                    autoplay: false,
                    "indicator-position": "none",
                    arrow: "always"
                  }
                },
                _vm._l(_vm.dialog.picture.fileList, function(item, index) {
                  return _c("el-carousel-item", { key: index }, [
                    item.type === 2 || item.type === 4 || item.type === 3
                      ? _c("img", {
                          staticClass: "img-preview",
                          attrs: { src: item.url }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    item.type === 0 || item.type === 1
                      ? _c("video", {
                          staticClass: "img-preview",
                          attrs: {
                            src: item.url,
                            controls: "controls",
                            type: "video/mp4",
                            playsinline: "",
                            "webkit-playsinline": ""
                          }
                        })
                      : _vm._e()
                  ])
                }),
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("anchor-cooperation-log-dialog", {
        ref: "anchorDetailDialog",
        on: { done: _vm.query }
      }),
      _vm._v(" "),
      _c("anchor-auditing-log-dialog", {
        ref: "anchorAuditingDialog",
        on: { done: _vm.query }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bb7e5c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bb7e5c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/anchor/quitGuildApprovalPage.vue
// module id = null
// module chunks = 